import React, { Fragment } from "react";

import { Icon, IconName, Heading } from "@telia/teddy";
import cn from "classnames";
import { BoxDataRow, ExistingService } from "../../../../../../models/transfer";
import { getFormattedPrice } from "../../../../../../shared/priceFormatter";
import TRANSFER_TEXT from "../../../text-consts";
import "./Agreement.less";

interface Agreement {
    data: BoxDataRow[];
    existingInsurance?: Pick<ExistingService, "product" | "price">;
    footer?: JSX.Element | JSX.Element[];
    icon?: IconName;
    imei?: string;
    model: string;
    price?: number;
    title: string;
}
const Agreement: React.FC<Agreement> = ({ title, price, data, model, imei, footer, existingInsurance }) => {
    return (
        <div className="agreement agreement__border">
            <div className="agreement__header">
                <Icon name="smartphone" className="agreement__icon" />
                <Heading mb="100" as="h4" variant="title-300" className="agreement__title">
                    {title}
                </Heading>
                {typeof price !== "undefined" && !isNaN(price) && (
                    <span className="information-table__value">
                        {getFormattedPrice(price)}
                        {TRANSFER_TEXT.SUMMARY.SUBSCRIPTION_INFORMATION.PER_MONTH}
                    </span>
                )}
            </div>
            <div className="agreement__subtitle">
                <div>{model}</div>
                {imei && <div>Imei: {imei}</div>}
            </div>
            <div className={cn("agreement__table-container")}>
                {data.map(({ label, value, strikethrough }, i, arr) => (
                    <Fragment key={`agreement__table--item-${label}-${i}`}>
                        <span className="agreement__table-label">{label}</span>
                        <span
                            className={cn("agreement__table-value", {
                                "agreement__table-value--strike": !!strikethrough,
                            })}
                        >
                            {value}
                        </span>
                        {arr.length - 1 !== i && <div className="agreement__table-hr"></div>}
                    </Fragment>
                ))}
            </div>
            {existingInsurance && (
                <div>
                    <div className="agreement__insurance-title">
                        {TRANSFER_TEXT.SUMMARY.AGREEMENT.RELATED_INSURANCE}
                    </div>
                    <div className="agreement__insurance-container">
                        <span className="agreement__insurance-name">{existingInsurance.product}</span>
                        <span>
                            {getFormattedPrice(existingInsurance.price.monthly)}
                            {TRANSFER_TEXT.SUMMARY.SUBSCRIPTION_INFORMATION.PER_MONTH}
                        </span>
                    </div>
                </div>
            )}
            {footer}
        </div>
    );
};

export default Agreement;
